import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-container">
      
        <div className="loading-spinner"></div>
        <h4>Carregando ...</h4>
      
      
    </div>
  );
};

export default Loading;
